import { render } from "./PromoCard.vue?vue&type=template&id=889e59e4&scoped=true"
import script from "./PromoCard.vue?vue&type=script&lang=js"
export * from "./PromoCard.vue?vue&type=script&lang=js"

import "./PromoCard.vue?vue&type=style&index=0&id=889e59e4&scoped=true&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-889e59e4"]])

export default __exports__